<template lang="pug">
  v-input(v-bind="$attrs" v-on="$listeners")
    v-card(flat color="grey lighten-3").sdo-radius.fill-width
      v-card-text
        .mb-3 {{ label }}

        v-row(
          align="center"
          no-gutters
        )
          v-col(cols="auto")
            .title.mr-4 c
          v-col
            sdo-datetime-field(
              :value="value && value.start"
              outlined
              v-bind="typeAttr"
              :date-props="timeProps"
              :time-props="timeProps"
              hide-details
              @input="inputValue('start', $event)"
            )
          v-col(cols="auto")
            .title.mx-4 по
          v-col
            sdo-datetime-field(
              :value="value && value.end"
              outlined
              v-bind="typeAttr"
              :date-props="timeProps"
              :time-props="timeProps"
              hide-details
              @input="inputValue('end', $event)"
            )
</template>

<script>

export default {
  props: {
    // value - ({ start: null, end: null, duration: null })
    value: { type: Object, default: null },
    type: { type: String, default: null },
    label: { type: String, default: 'Продолжительность' },
  },
  computed: {
    typeAttr() {
      const attrName = this.type ? this.type : null;
      return { [attrName]: true };
    },
    timeProps() {
      return {
        outlined: true,
        rounded: true,
        color: 'secondary',
      };
    },
  },
  methods: {
    inputValue(key, value) {
      this.$emit('input', {
        ...this.value,
        [key]: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-datetime-field__time {
    width: 100%;
  }
  .v-datetime-field__date {
    width: 100%;
  }
}
</style>
